import { ERankingType } from '@/types/auth'

export const RANKING_IMAGES = {
  [ERankingType.NEW]: 'header.ranking_image.new_user',
  [ERankingType.SILVER]: 'header.ranking_image.silver',
  [ERankingType.GOLD]: 'header.ranking_image.gold',
  [ERankingType.PLATINUM]: 'header.ranking_image.platinum',
}

export const RANKING_ICONS = {
  new: '/image/September2024/mceclip0_69.png',
  silver: '/image/September2024/mceclip1_14.png',
  gold: '/image/September2024/mceclip3_88.png',
  platinum: '/image/September2024/mceclip2_30.png',
}
